module.exports = __webpack_public_path__ + "static/media/ControlManifest.Input.6d93ec50.xml";